import React from 'react'

const CIRCLE_HEIGHT = 8
const LINE_HEIGHT = 2

export type DragLineProps = {
  position: 'top' | 'bottom'
}

export const DragLine = ({ position = 'top' }: DragLineProps) => {
  const positionStyle = position === 'top' ? { top: -6 } : { bottom: -6 }
  return (
    <div
      className="position-absolute width-full flexbox flexbox-align-center zindex-small"
      style={{ lineHeight: 0, left: -1 * CIRCLE_HEIGHT, ...positionStyle }}
    >
      <div
        style={{ height: CIRCLE_HEIGHT, width: CIRCLE_HEIGHT }}
        className="border-medium border-primary radius-round"
      />
      <div
        style={{ height: LINE_HEIGHT }}
        className="width-full background-primary"
      />
    </div>
  )
}
